module.exports = __webpack_public_path__ + "img/burger.5fcee6b0.png";